export default "__VITE_ASSET___4TJCwyI__"